import { toNumber } from '@shared/datastore/helpers';
import { transformMessage } from '@shared/datastore/messages';
import {
  ContextApi,
  ContextTypeApi,
  FolderApi,
  ThreadApi,
} from '../api-typings/messages/messages_types';
import { Thread, ThreadContext } from './thread.model';

// TODO: thread: any inference needs to go. ContextApi is incorrect.
export function transformThread(
  thread: ThreadApi,
  userId: string,
): Thread | undefined {
  const baseThread = thread.thread;

  if (!baseThread.id || !baseThread.owner) {
    return undefined; // FIXME Throw an error
  }

  const userReadTimes = Object.entries(baseThread.user_read_times || {}).reduce(
    (acc: Thread['userReadTimes'], [memberId, readTime]) => ({
      ...acc,
      [memberId]: readTime * 1000,
    }),
    {},
  );

  // hide threads with no last message
  if (!baseThread.message) {
    return undefined;
  }

  return {
    attachments: undefined,
    context: transformContext(baseThread.context),
    folder: thread.folder || FolderApi.INBOX,
    id: thread.id,
    isFake: false,
    isMuted: thread.is_muted || false,
    isRead: thread.is_read || false,
    members: baseThread.members || [],
    inactiveMembers: baseThread.inactive_members || [],
    message: baseThread.message
      ? transformMessage(baseThread.message)
      : undefined,
    messageCount: thread.message_count,
    messageUnreadCount: thread.message_unread_count || 0,
    otherMembers: baseThread.members.filter(m => m !== toNumber(userId)),
    owner: baseThread.owner,
    threadType: baseThread.thread_type,
    timeCreated: (baseThread.time_created || 0) * 1000,
    timeRead: (thread.time_read || 0) * 1000,
    timeUpdated: (thread.time_updated || 0) * 1000,
    userReadTimes,
  };
}

// Turn { type = 'none', id = undefined } => undefined
function transformContext(context?: ContextApi): ThreadContext | undefined {
  return context && context.id && context.type !== ContextTypeApi.NONE
    ? {
        type: context.type,
        id: context.id,
      }
    : undefined;
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/thread/thread.transformers.ts